import React from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';
import { BannerLayout, BannerMessage } from '@wix/da-ds/pkg/Banner/lego';
import HiddenIcon from '@wix/da-ds/pkg/Icons/32x32/Hidden';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import s from './StashBanner.scss';
const StashBanner = ({ className })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(BannerLayout, {
        size: "big",
        className: c(s['root'], className),
        body: [
            /*#__PURE__*/ React.createElement(HiddenIcon, {
                key: "icon",
                role: "presentation",
                size: IconSize.MEDIUM,
                disableDefaultColors: true
            }),
            /*#__PURE__*/ React.createElement(BannerMessage, {
                key: "message",
                weight: "reg"
            }, t('stashBanner.message', {
                postProcess: [
                    'reactPostprocessor',
                    'featureBrancher'
                ],
                prefix: /*#__PURE__*/ React.createElement("span", {
                    className: s['prefix-message']
                }, t('stashBanner.message.prefix'))
            }))
        ]
    });
};
StashBanner.displayName = 'StashBanner';
export default StashBanner;

//# sourceMappingURL=StashBanner.js.map